import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";
import App from "./App";
import AppProviders from "./providers/AppProviders";
import { appBasePath } from "@/config/env";
import "./i18n";
import "./index.css";
function hideInitialLoader() {
  const el = document.getElementById("app-initial-loader");
  if (!el) return;
  el.classList.add("app-initial-loader--hide");
  window.setTimeout(() => el.remove(), 280);
}
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  registerSW({ immediate: true });
}
createRoot(document.getElementById("root")).render(
  <StrictMode>
    <AppProviders>
      <BrowserRouter basename={appBasePath || void 0}>
        <App />
      </BrowserRouter>
    </AppProviders>
  </StrictMode>,
);
hideInitialLoader();
